import { render, staticRenderFns } from "./StockCheckRecordNew.vue?vue&type=template&id=bc6529fc&"
import script from "./StockCheckRecordNew.vue?vue&type=script&lang=ts&"
export * from "./StockCheckRecordNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports